<template>

  <div class="carousel-wrapper bg-light">
    <flickity class="carousel" ref="flickity" :options="flickityOptions">
      <div class="carousel-cell">
        <div class="carousel-media">
          <hero-video :size="'65%'" :fill="'cover'"></hero-video>
        </div>
        <div class="carousel-text">
        </div>
      </div>
      <div class="carousel-cell" v-for="(cell, index) in workshops" :key="index">
        <div class="carousel-media" :style="{'backgroundImage': 'url(' + cell.productImage.transformedSrc + ')'}" ></div>
        <div class="carousel-text" >
          <p class="workshop-title" v-html="cell.productTitle"></p>
          <p class="workshop-date" v-html="cell.productDate"></p>
          <a v-if="cell.productUrl" :href="cell.productUrl">Details &rarr;</a>
        </div>
      </div>
    </flickity>
  </div>

</template>

<script>

// import CaseStudiesData from '@/store/CaseStudiesData'
// import '../assets/styles/animate.css'
// import Waypoints from 'waypoints'
// import Vue from 'vue'
// import gql from 'graphql-tag'
const shopifyAccessToken = 'cd6c295cb0e4c351d45757ab4f18ec80'
const shopifyGraphQL = 'https://shop.hatopress.net/api/graphql'
const shopifyGraphQLQueryByHandle = function (handle = 'workshopcarousel') {
  return `
    {
      shop {
        name
        primaryDomain {
          url
          host
          sslEnabled
        }
      }
      collectionByHandle(handle: "workshopcarousel") {
        id
        products(first: 100) {
          edges {
            node {
              id
              title
              handle
              options {
                name
                values
              }
              images(first:3) {
                edges {
                  node {
                    altText
                    id
                    originalSrc
                    transformedSrc(maxWidth: 1600)
                  }
                }
              }
              variants(first: 1) {
                edges {
                  node {
                    title
                    selectedOptions {
                      name
                      value
                    }
                    image {
                      src
                    }
                    price
                    availableForSale
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}
const shopifyGraphQLConfig = {
  headers: {
    'X-Shopify-Storefront-Access-Token': shopifyAccessToken,
    'Content-Type': 'application/graphql'
  }
}
import HeroVideo from '@/components/HeroVideo'
import Flickity from '@/components/Flickity'
import _ from 'lodash'

export default {
  ready: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  beforeDestroy: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  components: {
    HeroVideo,
    Flickity
  },
  created () {
    // this.fetchData()
    this.runShopifyGraphQLRequest()
  },
  // created () {
  //   this.fetchData()
  // },
  data () {
    return {
      carousel: null,
      shop: null,
      workshops: null,
      shopify_collection_handle: 'workshopcarousel',
      flickityOptions: {
        // contain: true,
        initialIndex: 0,
        // prevNextButtons: false,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        // ,
        autoPlay: 3000
      }
    }
  },
  // computed: {
  // },
  mounted () {
    // this.initWaypoints()
    // this.fetchData()
  },
  methods: {
    async runShopifyGraphQLRequest () {
      const res = await this.$http.post(shopifyGraphQL, shopifyGraphQLQueryByHandle(this.shopify_collection_handle), shopifyGraphQLConfig)
      this.workshops = res.body.data.collectionByHandle.products.edges
      this.shop = res.body.data.shop

      //
      this.workshops = _.map(this.workshops, (workshop) => {
        workshop.productTitle = this.getShopifyProductTitle(workshop.node.title)
        workshop.productDate = this.getShopifyProductDate(workshop.node.title)
        workshop.productMonth = this.getShopifyProductMonth(workshop.node.title)
        workshop.productTime = this.getShopifyProductTime(workshop.node.title)
        workshop.productPrice = this.getShopifyProductPrice(workshop.node)
        workshop.productAvailableForSale = this.getShopifyProductAvailableForSale(workshop.node)
        workshop.productUrl = this.getShopifyProductURL(workshop.node.handle)
        workshop.productImage = this.getShopifyProductImage(workshop.node)
        // // workshop.customType = this.getFilterTypeName(workshop.productTitle)
        //
        if (workshop.productTitle.indexOf('Booth') > 0) {
          workshop.productTime = 'Selected dates in June and July'
          workshop.productDate = 'Selected dates in June and July'
        }

        return workshop
      })

      setTimeout(() => {
        this.$refs.flickity.initFlickity()
        // self.$refs.flickity.reloadCells()
        let flkty = this.$refs.flickity.flickity
        if (flkty) {
          // flkty.on('staticClick', this.flkty_staticClick)
        }
      }, 100)
    },
    getShopifyProductURL (productHandle) {
      return `${this.shop.primaryDomain.url}/collections/workshops/products/${productHandle}`
    },
    getShopifyProductPrice (product) {
      return `£${product.variants.edges[0].node.price}`
    },
    getShopifyProductImage (product) {
      // console.log(product.images.edges[1].node)
      return product.images.edges[1].node
    },
    getShopifyProductTags (product) {
      return `${product}`
    },
    getShopifyProductAvailableForSale (product) {
      return `${product.variants.edges[0].node.availableForSale}`
    },
    getShopifyProductTitle (productFullTitle) {
      return _.split(productFullTitle, /:/)[0]
    },
    getShopifyProductDate (productFullTitle) {
      let dateTime = _.split(productFullTitle, /:/)[1]
      let date = _.split(_.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, (month) => `${month}---`), '---')[0]
      return date
    },
    getShopifyProductMonth (productFullTitle) {
      let dateTime = _.split(productFullTitle, /:/)[1]
      let month = _.split(_.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, (month) => `---${month}---`), '---')[1]
      // month = [month]
      // console.log(`${month}`)
      if (productFullTitle.indexOf('Booth') > 0) {
        // month = ['June', 'July']
      }
      return month
    },
    getShopifyProductTime (productFullTitle) {
      let dateTime = _.split(productFullTitle, /:/)[1]
      let time = _.split(_.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, (month) => `${month}---`), '---')[1]
      time = _.trim(time, ',')
      time = _.trim(time, ' ')
      return time
    },
    flkty_staticClick: function (event, pointer, cellElement, cellIndex) {
      let self = this
      let flkty = self.$refs.flickity.flickity
      if (cellIndex === flkty.selectedIndex) {
        if (self.carousel[cellIndex] && self.carousel[cellIndex].url) {
          // disable carousel click
          // window.location.href = self.carousel[cellIndex].url
        } else {
          return
        }
      } else
      if (cellIndex >= flkty.selectedIndex) {
        // console.log('next')
        self.$refs.flickity.next()
      } else {
        // console.log('prev')
        self.$refs.flickity.previous()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.carousel-wrapper {
  /* margin: 1.5rem 0 2rem; */
  padding: 1rem 0 1rem;
  width: 100%;
  /*height: 500px;*/
  position: relative;
  background: #fafafa;
}

.carousel {
  /*position: absolute;*/
  top:0;
  left: 0;
  width: 100%;
  /*height: 100%;*/
}

.carousel-cell {
  /* width: 700px;
  height: 550px; */
  width: 900px;
  height: 550px;
  margin: 0 .5rem;
}

.carousel-media {
  /*width: 700px;*/
  /*height: 500px;*/
  width: 100%;
  height: 0;
  padding-bottom: 61%;
  margin: 0 auto;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /*pointer-events: none;*/
  /* cursor: pointer; */
  cursor: initial;
  position: relative;
}
.carousel-text {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 1rem;

  z-index: 99;
  margin: 1rem auto 0;
  text-align: left;
  cursor: pointer;
  max-width: 26em;
  color: white;
  text-shadow: 0px 0px 15px rgba(0,0,0,0.5);
  /*pointer-events: none;*/
}
.carousel-text p,
.carousel-text a {
  display: block;
  margin-top: .1rem;
  margin-bottom: 0;
}
.carousel-text p {
  font-weight: 500;
  margin-bottom: .1rem;
}
.carousel-text p.workshop-date {
  /* color: rgba(0,0,0,0.5); */
  font-size: 0.7rem;
}
.carousel-text a {
  display: inline-block;
  border: 1px solid;
  cursor: pointer;
  margin-top: .5rem;
  padding: .35rem 1rem .2rem;
  font-size: 0.7rem;
  /* text-decoration: underline; */
  /* color: hsl(159, 89%, 50%) */
  /* color: hsl(159, 89%, 50%) */
}
.carousel-text a:hover {
  /* background: rgba(0,0,0,0.2); */
  background: hsl(159, 89%, 50%);
  color: black;
  border-color: hsl(159, 89%, 50%);
  /* color: white; */
}


.flickity-enabled.is-draggable .flickity-viewport {
  cursor: pointer;
}

@media screen and (max-width: 1024px) {
  .carousel-cell {
    width: 90vw;
    height: auto;
  }
  .carousel-media {
    /*width: 600px;
    height: 400px;*/
  }
  .carousel-text {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    margin-top: 0;
    margin-left: 0;
    padding-left: 0;
    color: black;
  }
  .carousel-text p {
    font-size: 1rem;
  }
  .carousel-text a {
    font-size: .7rem;
  }
}
@media screen and (max-width: 768px) {
  .carousel-media {
  }
  .content-image {
    max-width: 400px;
  }
  .carousel-text {
  }
}
@media screen and (max-width: 640px) {
  .carousel-media {
  }
}
</style>



// WEBPACK FOOTER //
// Carousel.vue?ee467162